export default __webpack_public_path__ + "static/media/folder.5620027c.svg";